import { COUNTRY } from "./country-prefix"
import { getCountryToStorage } from "./feature-toggle"

export const enableElo = () => {
  const countryEnabledElo = [COUNTRY.PE, COUNTRY.CO, COUNTRY.CL, COUNTRY.MX, COUNTRY.EC]
  const countryToStorage = getCountryToStorage()
  if (!countryToStorage) {
    return false;
  }
  return countryEnabledElo.includes(countryToStorage)
}